<div
  class="full-page bg-black w-100"
  [style.background-image]="'url(' + ('login-registrations/registration-background.jpg' | contentAssetImage) + ')'"
>
  <div class="">
    <img class="logo mx-auto w-100 text-center" [src]="'logos/nav-logo.png' | contentAssetImage" />
    <div class="reg-container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
